import { useMemo } from 'react'

import EntitiesSelector from './EntitiesSelector'

const SectionGroupsSelector = ({ disabled, empty = false, multiple, style = {}, sectionGroups = [], values, onChange }) => {
  const sectionOptions = useMemo(() => sectionGroups.map(sectionGroup => ({
    label: sectionGroup.name,
    value: sectionGroup.id,
    tooltip: sectionGroup.sections.map(s => s.abbreviation).join(', '),
    entity: sectionGroup
  })), [sectionGroups])

  return (
    <EntitiesSelector
      disabled={disabled}
      entityOptions={sectionOptions}
      multiple={multiple}
      showSearch
      style={style}
      values={values}
      onChange={onChange}
      empty={empty}
    />
  )
}

export default SectionGroupsSelector
